/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbaording_Permission_List_Session_EndInputs */

const en_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus session is done`)
};

const ar_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت جلسة التركيز`)
};

const de_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus-Sitzung ist beendet`)
};

const es_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sesión de concentración ha finalizado`)
};

const fr_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La session de concentration est terminée`)
};

const it_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sessione di concentrazione è terminata`)
};

const ja_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中セッションが終わったとき`)
};

const ko_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 세션이 종료되었을 때`)
};

const pt_br_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessão de foco concluída`)
};

const ru_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сеанс фокусировки завершён`)
};

const th_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชันการโฟกัสเสร็จสิ้นแล้ว`)
};

const tr_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma oturumu tamamlandı`)
};

const zh_cn_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注完成`)
};

const zh_tw_onbaording_permission_list_session_end = /** @type {(inputs: Onbaording_Permission_List_Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注完成`)
};

/**
* | output |
* | --- |
* | "Focus session is done" |
*
* @param {Onbaording_Permission_List_Session_EndInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onbaording_permission_list_session_end = /** @type {((inputs?: Onbaording_Permission_List_Session_EndInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbaording_Permission_List_Session_EndInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbaording_permission_list_session_end(inputs)
	if (locale === "ar") return ar_onbaording_permission_list_session_end(inputs)
	if (locale === "de") return de_onbaording_permission_list_session_end(inputs)
	if (locale === "es") return es_onbaording_permission_list_session_end(inputs)
	if (locale === "fr") return fr_onbaording_permission_list_session_end(inputs)
	if (locale === "it") return it_onbaording_permission_list_session_end(inputs)
	if (locale === "ja") return ja_onbaording_permission_list_session_end(inputs)
	if (locale === "ko") return ko_onbaording_permission_list_session_end(inputs)
	if (locale === "pt_br") return pt_br_onbaording_permission_list_session_end(inputs)
	if (locale === "ru") return ru_onbaording_permission_list_session_end(inputs)
	if (locale === "th") return th_onbaording_permission_list_session_end(inputs)
	if (locale === "tr") return tr_onbaording_permission_list_session_end(inputs)
	if (locale === "zh_cn") return zh_cn_onbaording_permission_list_session_end(inputs)
	return zh_tw_onbaording_permission_list_session_end(inputs)
});